module.exports = "<div>\r\n    <div class=\"cortCase\">\r\n        <div class=\"cortCaseDetail\">\r\n            <h3>{{cortData.ctitle}}</h3>\r\n            <p>{{cortData.caseNum}}</p>\r\n            <div s-html=\"cortData.content\"></div>\r\n        </div>\r\n        <div class=\"upload-btn\">\r\n            <button on-click=\"goBack\">关闭</button>\r\n        </div>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/views/cortCase.html
// module id = 357
// module chunks = 1